/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import {
  wrapper,
  fieldContainerCss,
  labelCss,
  fieldCss,
  errorCss,
} from '../baseStyles/index.styles';
import { textAreaCss } from './index.styles';

class TextArea extends SafePureComponent {
  state = {
    shrink: false,
    focus: false,
  };

  onFocusTextArea = () => {
    this.setState({ focus: true, shrink: true });
  };

  onBlurTextArea = event => {
    const { value } = event.target;
    const shouldShrink = value.length > 0;
    this.setState({ focus: false, shrink: shouldShrink });
  };

  componentDidMount() {
    const shouldShrink =
      this.state.shrink || this.props.defaultValue.length > 0;
    this.setState({ shrink: shouldShrink });
  }

  componentDidUpdate(previousProps) {
    if (previousProps.defaultValue !== this.props.defaultValue) {
      const shouldShrink =
        this.state.shrink || this.props.defaultValue.length > 0;
      this.setState({ shrink: shouldShrink });
    }
  }

  safeRender() {
    const {
      id,
      placeholder,
      defaultValue,
      type,
      error,
      errorMessage,
      onChange,
      disabled,
      rows,
      maxlength,
      customCss,
    } = this.props;

    const { shrink, focus } = this.state;

    return (
      <div css={[wrapper, customCss]}>
        <label
          css={labelCss}
          data-shrink={shrink}
          data-focus={focus}
          data-error={error}
          htmlFor={id}
          id={`${id}-label`}
        >
          {placeholder}
        </label>
        <div
          css={fieldContainerCss}
          data-focus={focus}
          data-error={error}
          data-disabled={disabled}
        >
          <textarea
            css={[fieldCss, textAreaCss]}
            aria-invalid={error}
            aria-describedby={`${id}-helper-text`}
            id={id}
            type={type}
            defaultValue={defaultValue}
            disabled={disabled}
            maxLength={maxlength}
            onChange={onChange}
            onFocus={this.onFocusTextArea}
            onBlur={this.onBlurTextArea}
            rows={rows}
          />
        </div>
        <p id={`${id}-helper-text`} css={errorCss} data-disabled={disabled}>
          {error && errorMessage}
        </p>
      </div>
    );
  }
}

TextArea.displayName = 'TextArea';

TextArea.defaultProps = {
  placeholder: '',
  customCss: {},
  defaultValue: '',
  type: 'text',
  error: false,
  errorMessage: '',
  maxlength: '1000',
  onChange: () => {},
  disable: false,
  rows: 1,
};

TextArea.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  placeholder: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
  customCss: PropTypes.object,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  maxlength: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
};

export default TextArea;
